module.exports = __webpack_public_path__ + "static/media/green.0f096949.jpg";